/**
 * Тексты общих помощников: даты, номера, загрузка файлов, буфер обмена.
 *
 * Помощники живут в `shared/lib` и зовутся откуда угодно, поэтому их подписи
 * лежат отдельным пространством, а не в пространстве экрана.
 */
export const lib = {
  date: {
    today: 'сегодня, {{time}}',
    yesterday: 'вчера, {{time}}',
  },

  /** Подпись номера версии: встречается на восьми экранах. */
  versionLabel: 'версия {{no}}',

  upload: {
    tooLarge: 'Файл больше {{limit}} МБ. Сожмите фото и попробуйте снова.',
    offline: 'Сеть не отвечает. Проверьте соединение и попробуйте снова.',
    failed: 'Не получилось загрузить фото',
    requestFailed: 'Запрос не прошёл',
  },
} as const;
